function disableScrolling() {
  $('html').addClass('disable-scrolling');
}

function enableScrolling() {
$('html').removeClass('disable-scrolling');
}

function initHamburger(){
  const burger = $('.lm-header__hamburger');
  const inner = ('.lm-new-menu-mobile__inner');
  const close = $('.lm-new-menu-mobile__top svg')
  const accordian = $('.lm-new-menu-mobile__accrodian')

  accordian.on('click', function(){
    $(this).toggleClass('active');

    $(this).find( "svg" ).toggleClass("active");
  })

  burger.on('click', function(){
    disableScrolling();
    $(inner).addClass('active');
  })

  close.on('click', function(){
    enableScrolling();
    $(inner).removeClass('active');
  })
}

function isDesktop() {
  return window.innerWidth >= 768;
}

$(document).ready(function() {

  initHamburger()

  const $men = $('#js-men');
  const $menMenu = $('.lm-mega-menu__men')
  const $woman = $('#js-woman');
  const $womanMenu = $('.lm-mega-menu__woman')
  const $announce = $('.lm-header-announce')

  const $menMobile = $('.js-men')
  const $womanMobile = $('.js-woman')

  let mobileOpen = false

  $menMobile.on('click', function(){

    if( !$menMenu.hasClass('active')  ){
      disableScrolling()
    } else {
      enableScrolling()
    }

    $womanMenu.removeClass('active')
    $menMenu.toggleClass('active')
  })

  $womanMobile.on('click', function(){

    if( !$womanMenu.hasClass('active')  ){
      disableScrolling()
    } else {
      enableScrolling()
    }
    $menMenu.removeClass('active')
    $womanMenu.toggleClass('active')
  })

  if(isDesktop()){
      $men.on("click", function(e) {
        e.stopPropagation();
        $menMenu.toggleClass("active");
        $womanMenu.removeClass("active");
    });
    
    $woman.on("click", function(e) {
        e.stopPropagation();
        $womanMenu.toggleClass("active");
        $menMenu.removeClass("active");
    });
    
    // Close menu when clicking outside
    $(document).on("click", function() {
        $menMenu.removeClass("active");
        $womanMenu.removeClass("active");
    });

  }

  $men.mouseenter(function(){
    $menMenu.addClass('active')
    $womanMenu.removeClass('active')

  });

  $men.mouseleave(function(){
    setTimeout(function() {
      if($(".lm-mega-menu__men:hover").length == 0){
        $menMenu.removeClass('active')

      }
    }, 500);
  });

  $menMenu.mouseleave(function(){
    $menMenu.removeClass('active')
  });

  //woman

  $woman.mouseenter(function(){
    $womanMenu.addClass('active')
    $menMenu.removeClass('active')

  });

  $woman.mouseleave(function(){
    setTimeout(function() {
      if($(".lm-mega-menu__woman:hover").length == 0){
        $womanMenu.removeClass('active')

      }
    }, 500);
  });

  $womanMenu.mouseleave(function(){
    $womanMenu.removeClass('active')
  });


  const $labelSize = $(".variant-input label[for*='size']")

  $labelSize.css({"border-radius": "0px", "border": "solid black", "border-width": "1px"});

  $(".variant__label:contains(Size)").text('Select a size')

  $(".variant__label:contains(Color)").prepend('Choose a ')

  const $faqItem = $('.lm-product-description-accordian__description')

  $faqItem.on('click', function(){
    $(this).toggleClass('active');
  })

});

